module.exports = __webpack_public_path__ + "static/media/chevron-right.0d38a7c2.svg";